import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { stringifyPageSearch } from "@softmax/web-addresses/search";
import {
  automaticNavigationAllowed,
  useAutomaticNavigationAllowed,
} from "@softmax/web-features/navigation/activity";
import { gameNavigationHref, type GameNavigation } from "../game-types";
import { GamePending } from "./game-pending";

export function GameRedirect({
  sourceHref,
  navigation,
}: {
  readonly sourceHref: string;
  readonly navigation: GameNavigation;
}) {
  const router = useRouter();
  const canNavigate = useAutomaticNavigationAllowed();
  useEffect(() => {
    if (!canNavigate || !automaticNavigationAllowed()) return;

    const location = router.state.location;

    if (location.pathname + stringifyPageSearch(location.search) !== sourceHref)
      return;

    void router.navigate({
      href: gameNavigationHref({ navigation: navigation, href: location.href }),
      replace: true,
    });
  }, [sourceHref, navigation, router, canNavigate]);
  return <GamePending />;
}
